var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000023974318161074004980000006996673208324380595_",
    transform: "translate(14.178 -0.01) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000003814474097763988740000005680247209295473808_",
    transform: "translate(0.01 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9442",
    d: "M24,13.8H5.4c-2.9,0-3.5-0.6-3.5-3.4V-2.9c0-1.7,0.2-3.2,2.3-3.4c1.6-0.1,2.5,1.1,2.5,3.4 c0,3.2,0.1,6.5,0,9.7c0,1.5,0.5,2.1,2.1,2.1c10.1,0,20.2,0,30.4,0c1.6,0,2.1-0.6,2.1-2.1c-0.1-3,0-6,0-9.1c0-0.8,0.1-1.5,0.3-2.3 c0.2-1.2,1.4-1.9,2.5-1.7c1.1,0,2,1,2,2.1c0.1,5.3,0.1,10.5,0,15.8c0,1.8-1.5,2.1-3,2.1C36.6,13.8,30.3,13.8,24,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9443",
    d: "M20.6-24.9c-1.4,1.6-2.7,3.2-4.1,4.7c-0.5,0.6-1.1,1.1-1.7,1.6c-0.8,0.9-2.3,1-3.2,0.2 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.9-0.8-1-2.2-0.2-3.2c0.1-0.1,0.1-0.2,0.2-0.2c3.6-3.7,7.2-7.3,10.9-10.9c0.9-1,2.4-1,3.3-0.1 c0.1,0.1,0.2,0.2,0.2,0.3c3.5,3.5,7.1,7,10.6,10.5c1,0.8,1.2,2.2,0.4,3.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0.9-2.3,1-3.2,0.2 c-0.1-0.1-0.2-0.2-0.3-0.3c-2-2-3.8-4.1-5.7-6.1c-0.7,0.6-1.1,1.6-0.8,2.6c0,5.8,0,11.6,0,17.5c0,0.8,0,1.5-0.2,2.3 c-0.2,1.3-1.4,2.2-2.7,2c-1-0.2-1.8-1-2-2c-0.1-0.8-0.2-1.5-0.2-2.3v-19.5L20.6-24.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/Log Out.dfd4b4d3c8fc6eae068590d0fa8e1838.svg";
export { ForwardRef as ReactComponent };